import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import widgetWrapper from './widgetWrapper';

import './LabelWidget.scss';

class LabelWidget extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    subtitle: '',
    className: '',
  };

  render() {
    const {
      title,
      subtitle = '',
      className = 'float-left',
    } = this.props;
    const mix = {};
    mix.LabelWidget = true;
    if (className) {
      mix[className] = true;
    }
    return (
      <div className={classnames(mix)}>
        <div className="header">
          <div className="content">
            <h1 className="title">{title}</h1>
            <h1 className="subtitle">{subtitle}</h1>
          </div>
        </div>
      </div>
    );
  }
}

export default widgetWrapper(LabelWidget);
